module.exports = __webpack_public_path__ + "img/tool_icon1.1256748c.svg";